// The review-checkpoint voice quiz's store. In its own file, like the
// clinical exam station's, so the keyboard-shortcut guard
// (utils/shouldBlockGlobalKeyboardShortcut.ts) can read it without importing
// the whole global store. globalStore re-exports it, so existing imports hold.
import { create } from "zustand";

// The review-checkpoint voice challenge — a lighter, ~1-minute formative voice
// quiz that fires at an occasional review checkpoint. Kept in its OWN store
// (not the subscription/upsell store) because it's a review-flow feature, not
// an upsell: it's opened by the checkpoint trigger in HelperMethodsHook and
// rendered by ReviewCheckpointChallengePage. `reviewCheckpointChallenge` is
// the open payload (the concept being quizzed + deck grounding); null = closed.
export interface ReviewCheckpointChallengePayload {
  concept: string;
  deckId?: string;
  deckName?: string;
  passageContext?: string;
  exploredPassageQuestions?: Array<{
    question: string;
    correctAnswer?: string;
    learnerAnswer?: string;
  }>;
  // The language the agent should speak/quiz in — resolved from the deck/card at
  // trigger time so non-English decks get a localized opener (not hardcoded
  // English). Falls back to "English" when unresolved.
  language?: string;
}

interface ReviewCheckpointChallengeStoreState {
  reviewCheckpointChallenge: ReviewCheckpointChallengePayload | null;
  openReviewCheckpointChallenge: (challenge: ReviewCheckpointChallengePayload) => void;
  closeReviewCheckpointChallenge: () => void;
}

export const useReviewCheckpointChallengeStore = create<ReviewCheckpointChallengeStoreState>((set) => ({
  reviewCheckpointChallenge: null,
  openReviewCheckpointChallenge: (challenge) => set({ reviewCheckpointChallenge: challenge }),
  closeReviewCheckpointChallenge: () => set({ reviewCheckpointChallenge: null }),
}));
